import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Bubble from './Bubble'

import iconFile from 'assets/icons/ico-attachment-active.svg'
import Icon from '../../shared/Icon'

const FileContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

const FileMessage = ({ payload, isLeft, avatar, endOfBlock, createdAt}) => (
  <Bubble
    isLeft={isLeft}
    avatar={avatar}
    endOfBlock={endOfBlock}
    width='50%'
    timestamp={createdAt}
    stampStyle='text'
  >
    <FileContent>
      <Icon src={iconFile} />
      <a href={payload.url ? payload.url : '#'} >{ `Download ${payload.title || 'file'}`}</a>
    </FileContent>
  </Bubble>
)

export default FileMessage

FileMessage.propTypes = {
  avatar: PropTypes.any,
  isLeft: PropTypes.bool,
  payload: PropTypes.object.isRequired,
  endOfBlock: PropTypes.bool,
  createdAt: PropTypes.instanceOf(Date)
}